import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Flex, Form, Image, Row, Space } from 'antd';
import { MyInput } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

const ProfileSetting = () => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)
    const dispatch = useDispatch()
    const { profiledata } = useSelector(state => state?.ProfilegetApi)
    useEffect(() => {
        dispatch(actionsApi?.getUpdateProfile())
    }, [dispatch])

    useEffect(() => {
        if (profiledata) {
            form.setFieldsValue({
                name: profiledata?.firstName + " " + profiledata?.lastName || '',
                email: profiledata?.email || '',
                phoneNo: + profiledata?.phoneNo || '',
            });
        }
    }, [profiledata, form]);

 
    const profilepost = async (formData) => {
        setLoading(true);
        const result = await apiCalls.ProfileApi.profilepost(formData);
        if(result){
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={profilepost}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Flex justify='center' className='my-4'>
                        <Image src='/assets/images/logo.png' preview={false} width={120} height={120} style={{objectFit:'cover'}} className='radius-12'/>
                    </Flex>
                </Col>
                <Col lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        autoFocus
                        name="name"
                        label="Name"
                        placeholder=""
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="email"
                        label="Email Address"
                        placeholder=""
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        name="phoneNo"
                        type='number'
                        label="Phone Number"
                        size='large'
                    />
                </Col>
                <Col span={24}>
                    <Divider />
                </Col>
                <Col span={24}>
                    <Space className="w-100 right">
                        <Button 
                            className="btncancel"
                        >
                            Cancel
                        </Button>
                        <Button  
                            block
                            className='btnsave'
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Update
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    );
};

export { ProfileSetting };
